module.exports = __webpack_public_path__ + "img/view3d-notice-light-dhfx1.a77757ec.png";